<div class="grid grid-cols-12 my-20">
  <div class="col-start-2 col-span-10">
    <h1 class="self-stretch text-center justify-start text-gray-900 text-4xl font-extrabold font-['Inter'] leading-[54px]">
      Aviso Legal - Casato Brasil
    </h1>
    <p class="text-center justify-start text-gray-500 text-xl font-normal font-['Inter'] leading-loose">
      Última atualização: 6 de maio de 2026
    </p>

    <div class="self-stretch justify-start mt-20 text-gray-500 text-base font-normal font-['Inter'] leading-normal">
      <section class="mt-6">
        <h2 class="font-bold">1. Identificação da Empresa e Operação da Plataforma</h2>
        <p class="mt-1">
          O site e a plataforma Casato Brasil são operados por Muse Digital, empresa estabelecida nos Países Baixos, responsável pela gestão comercial e operacional da plataforma.
        </p>
        <p class="mt-1">
          A Muse Digital é responsável pela prestação dos serviços digitais, operação da Plataforma, relacionamento com usuários, contratação de fornecedores especializados, processamento de pagamentos por parceiros autorizados e cumprimento das obrigações legais aplicáveis.
        </p>
        <p class="mt-1">
          “Casato Brasil” é marca utilizada para fins comerciais e de comunicação, não constituindo pessoa jurídica autônoma no Brasil, nem estabelecimento físico próprio em território brasileiro.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">2. Natureza da Plataforma e Limitação de Escopo</h2>
        <p class="mt-1">A Plataforma disponibiliza ferramentas tecnológicas voltadas a:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>consolidação e organização de informações públicas relacionadas a imóveis em leilão</li>
          <li>recursos de análise, estimativas e apoio à decisão</li>
          <li>alertas automatizados sobre oportunidades, datas e movimentações</li>
          <li>apoio informacional para tomada de decisão</li>
        </ul>
        <p class="mt-1">
          Os conteúdos e funcionalidades possuem caráter exclusivamente informativo, estimativo e auxiliar.
        </p>
        <p class="mt-1">A Plataforma não constitui:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>consultoria jurídica, financeira, contábil, tributária, imobiliária ou de investimentos</li>
          <li>recomendação personalizada</li>
          <li>intermediação de lances</li>
          <li>representação do usuário perante terceiros</li>
          <li>promessa de retorno financeiro</li>
          <li>garantia de aquisição de imóvel ou resultado em leilão</li>
        </ul>
        <p class="mt-1">
          A Casato Brasil não atua como corretora, leiloeira, imobiliária ou participante dos leilões anunciados.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">3. Uso de Dados, Processamento Automatizado e Inteligência Artificial</h2>
        <p class="mt-1">As informações apresentadas podem ser estruturadas a partir de:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>dados públicos divulgados por leiloeiros, instituições financeiras, cartórios, tribunais ou órgãos oficiais</li>
          <li>informações disponibilizadas por terceiros</li>
          <li>processamento automatizado, incluindo sistemas baseados em inteligência artificial</li>
        </ul>
        <p class="mt-1">
          O usuário reconhece que sistemas automatizados possuem limitações técnicas e que podem ocorrer imprecisões, inconsistências, atrasos, omissões ou desatualizações.
        </p>
        <p class="mt-1">
          Não há garantia de exatidão absoluta, atualização contínua ou completude integral dos dados apresentados.
        </p>
        <p class="mt-1">
          A Casato Brasil não realiza decisões automatizadas que produzam efeitos jurídicos relevantes ao usuário.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">4. Simulações e Projeções</h2>
        <p class="mt-1">
          As simulações financeiras, estimativas de custos e projeções disponíveis na Plataforma baseiam-se em parâmetros fornecidos pelo usuário e premissas automatizadas.
        </p>
        <p class="mt-1">Os resultados:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>possuem caráter estimativo</li>
          <li>podem variar conforme condições reais de mercado</li>
          <li>dependem de fatores jurídicos, tributários, documentais e operacionais específicos</li>
          <li>não substituem análise profissional individualizada</li>
        </ul>
        <p class="mt-1">
          As simulações não configuram recomendação de investimento, promessa de rentabilidade ou oferta pública.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">5. Alertas e Notificações</h2>
        <p class="mt-1">
          Os alertas disponibilizados possuem natureza automatizada e informativa, sendo enviados de forma periódica conforme critérios definidos pela Plataforma e disponibilidade técnica dos sistemas utilizados.
        </p>
        <p class="mt-1">A Casato Brasil não garante:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>envio imediato ou em tempo real</li>
          <li>recebimento efetivo pelo usuário</li>
          <li>periodicidade exata de cada notificação</li>
          <li>ausência de falhas técnicas, atrasos ou interrupções</li>
          <li>disponibilidade contínua dos canais de envio</li>
        </ul>
        <p class="mt-1">
          O acompanhamento oficial de datas, editais, regras e condições dos leilões permanece sob responsabilidade exclusiva do usuário.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">6. Pagamentos e Assinaturas</h2>
        <p class="mt-1">
          Os pagamentos são processados por provedores terceirizados especializados e certificados, incluindo Stripe ou parceiros equivalentes.
        </p>
        <p class="mt-1">
          A Plataforma não armazena dados completos de cartão de crédito ou credenciais financeiras sensíveis.
        </p>
        <p class="mt-1">
          Os valores cobrados serão apresentados ao usuário no momento da contratação, de acordo com o plano selecionado e condições então vigentes.
        </p>
        <p class="mt-1">
          As cobranças poderão aparecer no extrato, fatura ou comprovante de pagamento sob a identificação “CASATO BRASIL” ou descrição equivalente relacionada à Plataforma.
        </p>
        <p class="mt-1">
          Condições de teste gratuito, renovação automática, cancelamento, cobrança recorrente e reembolsos constam nos Termos de Uso aplicáveis.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">7. Propriedade Intelectual</h2>
        <p class="mt-1">
          Todos os conteúdos, marcas, textos, layouts, elementos visuais, software, bases de dados e recursos tecnológicos da Plataforma pertencem à Muse Digital, à marca Casato Brasil ou a seus respectivos licenciadores, sendo protegidos pela legislação aplicável.
        </p>
        <p class="mt-1">É proibida, sem autorização prévia e expressa:</p>
        <ul class="mt-1 list-disc pl-6">
          <li>reprodução total ou parcial relevante</li>
          <li>redistribuição de conteúdo</li>
          <li>scraping ou coleta automatizada massiva de dados</li>
          <li>engenharia reversa</li>
          <li>exploração comercial não autorizada</li>
          <li>revenda de acessos ou compartilhamento indevido de contas</li>
        </ul>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">8. Limitação de Responsabilidade</h2>
        <p class="mt-1">
          Na máxima extensão permitida por lei, a Casato Brasil e a Muse Digital não se responsabilizam por:
        </p>
        <ul class="mt-1 list-disc pl-6">
          <li>decisões tomadas com base nas informações disponibilizadas</li>
          <li>atos, omissões ou alterações promovidas por leiloeiros, bancos, cartórios, tribunais ou órgãos públicos</li>
          <li>perdas indiretas, lucros cessantes ou oportunidades perdidas</li>
          <li>falhas técnicas de terceiros</li>
          <li>indisponibilidades temporárias da Plataforma</li>
          <li>alertas não recebidos ou recebidos com atraso</li>
          <li>divergências entre dados exibidos e informações oficiais atualizadas</li>
        </ul>
        <p class="mt-1">
          Nada neste Aviso Legal exclui responsabilidade quando a exclusão não for permitida pela legislação aplicável.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">9. Proteção de Dados</h2>
        <p class="mt-1">
          O tratamento de dados pessoais ocorre de acordo com a legislação aplicável, incluindo, quando cabível, o Regulamento Geral de Proteção de Dados da União Europeia (GDPR) e a Lei Geral de Proteção de Dados do Brasil (LGPD), conforme descrito na Política de Privacidade da Plataforma.
        </p>
        <p class="mt-1">
          A Casato Brasil poderá utilizar fornecedores especializados para hospedagem, autenticação, segurança e pagamentos, incluindo Amazon Web Services e Stripe.
        </p>
      </section>

      <section class="mt-6">
        <h2 class="font-bold">10. Contato</h2>
        <p class="mt-1">Para dúvidas legais, suporte ou solicitações relacionadas à Plataforma:</p>
        <p class="mt-1">
          <a href="mailto:contato&#64;casatobrasil.com.br" class="text-blue-600 hover:underline">contato&#64;casatobrasil.com.br</a>
        </p>
      </section>
    </div>
  </div>
</div>
